$(document).ready(function(){
  function getClosest(a, numberD1) {
    return numberD1 - a.reduce(function(closest, v) {
        return numberD1 >= v ? Math.min(numberD1-v, closest) : closest;
    }, 1e100);
  }  
  
  var quantityInput = $('input[name="quantity"]');
  
  var minQuantity = parseInt($('input[name="id"]:first').prev().text());
  var quantitySelected = parseInt($('input[name="id"]:checked').prev().text());
  var quantityStep,quantityNext;
  var quantityArr = [];
  $('.variantQuantity').each(function() {
    quantityArr.push(parseInt($(this).text()));
  });
  function newVars(){
    if($('input[name="id"]:checked').parents('tr').prev().length){
      quantityStep = parseInt($('input[name="id"]:checked').parents('tr').prev().find('input[name="id"]').prev().text());
    }else{
      quantityStep = quantitySelected;
    }

    if($('input[name="id"]:checked').parents('tr').next().length){
      quantityNext = parseInt($('input[name="id"]:checked').parents('tr').next().find('input[name="id"]').prev().text());
    }else{
      quantityNext = 99999;
    }
  }
  newVars();

  function updatePrice(){
    var totalPrice = parseInt(quantityInput.val()) * parseInt($('input[name="id"]:checked').attr('data-price'));
    $('.price-total').text(Shopify.formatMoney(totalPrice), window.theme.moneyFormat);
  }
  updatePrice();
  
  $('.ProductForm_variants tr:not(.soldout)').click(function(){
    $(this).find('input[type="radio"]').prop("checked", true);
    $(this).siblings().removeClass('is_active');
    $(this).addClass('is_active');
    quantityInput.val($(this).attr('data-quantity'));
  	newVars();
    updatePrice();
  });

  $('.decrease-quantity').click(function(){
    var quantitySelected = parseInt($('input[name="id"]:checked').prev().text()); 
    var newVal = parseInt(quantityInput.val())-quantityStep;
    if(quantitySelected == parseInt(quantityInput.val())){
      	$('tr[data-quantity="'+quantityStep+'"]').find('input[name="id"]').prop("checked", true).trigger("click");
      	newVars();
    	var newVal = parseInt(quantityInput.val())-quantityStep;
      	if(newVal < parseInt($('input[name="id"]:checked').prev().text())){
      		quantityInput.val(parseInt($('input[name="id"]:checked').prev().text()));
        }else{
      		quantityInput.val(newVal);
        }
    }else if(newVal <= minQuantity ){
    	quantityInput.val(minQuantity);
      	$('tr[data-quantity="'+minQuantity+'"]').find('input[name="id"]').prop("checked", true).trigger("click");
      	newVars();
    }else if(newVal < quantitySelected){
    	quantityInput.val(quantitySelected);
      	newVars();
    }else{
      	quantityInput.val(newVal);
    }
    updatePrice();
  });
  
  $('.increase-quantity').click(function(){
    var newVal = parseInt(quantityInput.val())+quantityStep;
    if(newVal >= quantityNext){
    	quantityInput.val(quantityNext);
      	$('tr[data-quantity="'+quantityNext+'"]').find('input[name="id"]').prop("checked", true).trigger("click");
      	newVars();
    }else{
    	quantityInput.val(newVal);
    }
    updatePrice();
  });
  
  
  if($('#existedQuantity').length){
  	quantityInput.val(parseInt($('#existedQuantity').text()));
    var newVal = getClosest(quantityArr,parseInt($('#existedQuantity').text()));
    $('tr[data-quantity="'+newVal+'"]').trigger("click");
    updatePrice();
  }
  
  $('.Minicart__Checkout').click(function (e) {
    e.preventDefault();
    document.location = '/cart';
  });
  
  $('#giftwrap_checkbox').change(function () {
    if($(this).prop('checked')) {
      document.location = '/cart/add?id=19978566434886&quantity=1';
    } else {
      document.location = '/cart/change?id=19978566434886&quantity=0';
    }
  });
  
});